// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyACk6o-yqAtHPn74WUyGM-cd19RmJ9t4Ao",
    authDomain: "inai-455513.firebaseapp.com",
    databaseURL: "https://inai-455513-default-rtdb.firebaseio.com",
    projectId: "inai-455513",
    storageBucket: "inai-455513.firebasestorage.app",
    messagingSenderId: "929071234092",
    appId: "1:929071234092:web:49ac37db190e161365a589",
    measurementId: "G-Y1P4ZHVLYD"
  };
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app, "mold-day");
const analytics = getAnalytics(app);
import { getStorage } from "firebase/storage";
const storage = getStorage(app);
export { db, storage };
